<script setup lang="ts">
import { onBeforeMount } from 'vue'

import { useRouter } from 'vue-router'

const router = useRouter()

onBeforeMount(() => {
  router.push({ name: 'login' })
})
</script>

<template>
  <main></main>
</template>
